import type { FormSummaryJSONObject } from '@ikegps/core-api';
import { ModalFormComponent, type ModalFormComponentCtx } from '../../components/modal.form/modal.form.component';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { Services } from '../../services';

export class FormArchiveConfirmModal extends ModalFormComponent {
	formSummary: FormSummaryJSONObject;

	constructor(ctx: ModalFormComponentCtx, formSummary: FormSummaryJSONObject) {
		super(ctx);
		this.formSummary = formSummary;
	}

	get nodes(): MithrilVNode {
		return m('p', Translate(T.FORM_ARCHIVE_CONFIRM, { name: this.formSummary.displayname }));
	}

	override async submit() {
		await Services.Form.archive(this.formSummary.uuid);
	}
}
